var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import React from "react";
import AccountDetails from "./Overview/AccountDetails";
import PersonalDetails from "./Overview/PersonalDetails";
import ProfileDetails from "./Overview/ProfileDetails";
import { useSelector } from "react-redux";
import di from "../di/serviceLocator";
import FamilyTaggingPop from "./Overview/FamilyTaggingPop";
import Loader from "../../../../../shared-library/components/Loader";
var ClientOverview = function () {
    var _a = __read(React.useState(), 2), clientOverviewDataState = _a[0], setClientOverviewDataState = _a[1];
    var _b = __read(React.useState(false), 2), familytagging = _b[0], setfamilytagging = _b[1];
    var clientOverviewData = useSelector(function (state) { return state.Clients.ClientOverview.reducersData.data; });
    var _c = useSelector(function (state) { return state.Clients.ClientOverview.commonData; }), overviewLoader = _c.loader, errorData = _c.errorData;
    var selectedAcount = useSelector(function (state) { return state.Clients.ClientSearch.reducersData.selected; });
    var handleClientOverviewCall = function () {
        di.clients.getClientOverviewData({
            accCode: selectedAcount.accountCode,
        });
    };
    React.useEffect(function () {
        if (selectedAcount && selectedAcount.accountCode) {
            handleClientOverviewCall();
        }
    }, [selectedAcount]);
    React.useEffect(function () {
        setClientOverviewDataState(clientOverviewData);
    }, [clientOverviewData]);
    return (React.createElement(React.Fragment, null, familytagging ? (React.createElement(FamilyTaggingPop, { setFamilyTagging: setfamilytagging })) : (React.createElement(React.Fragment, null, overviewLoader ? (React.createElement("div", { className: "position-relative client-loader" },
        React.createElement(Loader, null))) : (React.createElement(React.Fragment, null,
        React.createElement(PersonalDetails, { clientOverviewData: clientOverviewDataState }),
        React.createElement(ProfileDetails, { clientOverviewData: clientOverviewDataState, setFamilyTagging: setfamilytagging, handleClientOverviewCall: handleClientOverviewCall }),
        React.createElement(AccountDetails, { clientOverviewData: clientOverviewDataState })))))));
};
export default ClientOverview;
